import axios from 'axios';
import { MessageBox } from 'mint-ui';

// 定义版本检查服务
const versionCheck = {
  // 保存当前版本号
	currentVersion: '',
  // 保存当前构建ID
	currentBuildId: '',
  // 上一次检查的时间
	lastCheckTime: 0,
  // 检查间隔时间（默认1小时）
	checkInterval: 60 * 60 * 1000,
  // 定时器引用
	timer: null,
  // 是否已显示更新提示
	isUpdateNoticeShown: false,
  // 初始化版本检查
	init(version) {
		this.currentVersion = version;
		this.startCheck();
    // 用户从其他标签页或应用切回时，重新检查版本
		window.addEventListener('visibilitychange', () => {
			if (document.visibilityState === 'visible') {
				// 页面可见时，立即检查版本并确保定时器正常运行
				this.checkVersion(true);
				this.ensureTimerRunning();
			} else {
				// 页面不可见时，清除定时器以节省资源
				this.clearTimer();
			}
		});
	},
  // 确保定时器正在运行
	ensureTimerRunning() {
    // 如果定时器不存在，则重新启动
		if (!this.timer) {
			this.timer = setInterval(() => {
				this.checkVersion();
			}, this.checkInterval);
		}
	},
  // 清除定时器
	clearTimer() {
		if (this.timer) {
			clearInterval(this.timer);
			this.timer = null;
		}
	},
  // 开始定时检查
	startCheck() {
		this.checkVersion(true);
    // 清除可能存在的旧定时器
		this.clearTimer();
    // 设置新的定时器
		this.timer = setInterval(() => {
			this.checkVersion();
		}, this.checkInterval);
	},
  // 检查版本
	checkVersion(skipTimeCheck = false) {
    // 防止频繁检查
		const now = Date.now();
		if (!skipTimeCheck && now - this.lastCheckTime < this.checkInterval) {
			return;
		}
		this.lastCheckTime = now;

    // 向服务端请求版本信息
    // 使用时间戳防止缓存
		axios.get('/version.json?t=' + now, {
			headers: {
				'Cache-Control': 'no-cache, no-store, must-revalidate',
				'Pragma': 'no-cache',
				'Expires': '0'
			}
		})
			.then(response => {
				const serverVersion = response.data.version;
				const serverBuildId = response.data.buildId;

				// 比较版本号或构建ID
				// 如果版本号不同或构建ID不同，就提示更新
				if ((serverVersion && serverVersion !== this.currentVersion) &&
					(serverBuildId && serverBuildId !== this.currentBuildId)) {

					// 记录服务端的构建ID
					this.currentBuildId = serverBuildId;
					this.currentVersion = serverVersion;
					this.notifyUpdate();
				}
			})
	},
  // 通知用户更新
	notifyUpdate() {
    // 如果已经显示了更新提示，则不再显示
		if (this.isUpdateNoticeShown) {
			return;
		}

    // 标记已显示更新提示
		this.isUpdateNoticeShown = true;
		// 添加时间戳参数强制刷新并清除缓存
		// 保存当前URL中的查询参数
		const currentUrl = new URL(window.location.href);
		const currentParams = currentUrl.searchParams;
		const newParams = new URLSearchParams();
		// 复制所有现有参数
		for (const [key, value] of currentParams) {
			newParams.append(key, value);
		}
		// 添加时间戳参数
		newParams.append('refresh_t', Date.now());
		// 构建新的URL
		const newUrl = `${currentUrl.pathname}?${newParams.toString()}`;
		MessageBox({
			title: '发现新版本',
			message: '系统功能已更新，请关闭软件后重新开启，或联系服务人员',
			showCancelButton: false,
			confirmButtonText: '立即刷新',
			confirmButtonClass: 'mint-msgbox-confirm',
			closeOnPressEscape: false,
			closeOnClickModal: false
		}).then(action => {
			// 用户点击了"立即刷新"
			if (action === 'confirm') {
        // 刷新前重置标志，避免刷新过程中出现问题
				this.isUpdateNoticeShown = false;
        // 添加时间戳参数强制刷新并清除缓存
				window.location.replace(newUrl);
			}
      // 注意：在mint-ui的MessageBox中，如果showCancelButton为false，
      // 则只有确认按钮，不会走到else分支
		}).catch(() => {
      // 弹窗被关闭（如点击右上角关闭按钮）
      // 此时重置标志，允许未来检测新版本
			this.isUpdateNoticeShown = false;
			window.location.replace(newUrl);
		});
	}
};

export default versionCheck;



// WEBPACK FOOTER //
// ./src/assets/js/versionCheck.js